
export class Utils {
    public static DivideCard(card: string): string[]{
        let ced = card.split("");
        let ced_arr = []
        let temp_arr = ""
        while(ced.length > 0){
          temp_arr = ced.pop() + temp_arr
          if(temp_arr.length == 4){
            ced_arr.push(temp_arr)
            temp_arr = ""
          }
        }
        ced_arr.push(temp_arr);
        return ced_arr.reverse()
    }

    public static BussinessCard(card: string): string[]{
        let ced = card.split("");
        let ced_arr = []
        let temp_arr = ""
        while(ced.length > 0){
          temp_arr = ced.pop() + temp_arr
          if(temp_arr.length == 6 && ced_arr.length == 0){
            ced_arr.push(temp_arr)
            temp_arr = ""
          } else if(temp_arr.length == 3 && ced_arr.length == 1){
            ced_arr.push(temp_arr)
            temp_arr = ""
          }
        }
        ced_arr.push(temp_arr)
        return ced_arr.reverse()
    }
}
